import { useState, useEffect, useRef } from "react";
import { BookOpen, Mail, Globe } from "lucide-react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
  }
}

// Google Analytics tracking function
const trackLinkClick = (linkName: string, url: string) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", "link_click", {
      event_category: "outbound",
      event_label: linkName,
      value: url,
    });
  }
};

const links = [
  {
    // title: "About Us",
    title: "centurygroup.co.in",
    url: "https://centurygroup.co.in/",
    icon: <Globe className="h-6 w-6 text-blue-600" />,
    // icon: <img src="/assets/imgs/logo.png" height={30} width={30} alt="" />,
    bgColor: "bg-white backdrop-blur-sm ",
    delay: "delay-100",
  },
  {
    title: "Nakshatra Nagar Brochure",
    url: "https://drive.google.com/file/d/1WfDdnW6dPlehbit7Z4DIyAMYQOXNxxzJ/view?usp=sharing",
    icon: <BookOpen className="h-6 w-6 text-black" />,
    bgColor: "bg-white backdrop-blur-sm ",
    delay: "delay-200",
  },
  {
    title: "Google Map",
    url: "https://maps.app.goo.gl/fFa6XUQaFUEHwV858",
    // icon: <MapPin className="h-6 w-6 text-red-600" />,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width="30"
        height="30"
        viewBox="0 0 48 48"
      >
        <path
          fill="#48b564"
          d="M35.76,26.36h0.01c0,0-3.77,5.53-6.94,9.64c-2.74,3.55-3.54,6.59-3.77,8.06	C24.97,44.6,24.53,45,24,45s-0.97-0.4-1.06-0.94c-0.23-1.47-1.03-4.51-3.77-8.06c-0.42-0.55-0.85-1.12-1.28-1.7L28.24,22l8.33-9.88	C37.49,14.05,38,16.21,38,18.5C38,21.4,37.17,24.09,35.76,26.36z"
        ></path>
        <path
          fill="#fcc60e"
          d="M28.24,22L17.89,34.3c-2.82-3.78-5.66-7.94-5.66-7.94h0.01c-0.3-0.48-0.57-0.97-0.8-1.48L19.76,15	c-0.79,0.95-1.26,2.17-1.26,3.5c0,3.04,2.46,5.5,5.5,5.5C25.71,24,27.24,23.22,28.24,22z"
        ></path>
        <path
          fill="#2c85eb"
          d="M28.4,4.74l-8.57,10.18L13.27,9.2C15.83,6.02,19.69,4,24,4C25.54,4,27.02,4.26,28.4,4.74z"
        ></path>
        <path
          fill="#ed5748"
          d="M19.83,14.92L19.76,15l-8.32,9.88C10.52,22.95,10,20.79,10,18.5c0-3.54,1.23-6.79,3.27-9.3	L19.83,14.92z"
        ></path>
        <path
          fill="#5695f6"
          d="M28.24,22c0.79-0.95,1.26-2.17,1.26-3.5c0-3.04-2.46-5.5-5.5-5.5c-1.71,0-3.24,0.78-4.24,2L28.4,4.74	c3.59,1.22,6.53,3.91,8.17,7.38L28.24,22z"
        ></path>
      </svg>
    ),
    bgColor: "bg-white backdrop-blur-sm ",
    delay: "delay-300",
  },
  {
    title: "Chat on WhatsApp",
    url: "https://wa.me/918817521921",
    // icon: <MessageCircle className="h-6 w-6 text-green-500" />,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="#fff"
        aria-label="WhatsApp"
        viewBox="0 0 512 512"
        width={22}
        height={22}
        id="whatsapp"
      >
        <rect width="512" height="512" fill="#45d354" rx="15%"></rect>
        <path d="M308 273c-3-2-6-3-9 1l-12 16c-3 2-5 3-9 1-15-8-36-17-54-47-1-4 1-6 3-8l9-14c2-2 1-4 0-6l-12-29c-3-8-6-7-9-7h-8c-2 0-6 1-10 5-22 22-13 53 3 73 3 4 23 40 66 59 32 14 39 12 48 10 11-1 22-10 27-19 1-3 6-16 2-18"></path>
        <path d="M264 384c-41 0-72-22-72-22l-49 13 12-48s-20-31-20-70c0-72 59-132 132-132 68 0 126 53 126 127 0 72-58 131-129 132m-159 29l83-23a158 158 0 0 0 230-140c0-86-68-155-154-155a158 158 0 0 0-137 236"></path>
        {/* <span className="text-sm font-medium">WhatsApp</span> */}
      </svg>
    ),
    bgColor: "bg-white backdrop-blur-sm ",
    delay: "delay-400",
  },
  {
    title: "Instagram",
    url: "https://www.instagram.com/centurygroup.21",
    // icon: <Instagram className="h-6 w-6 text-pink-500" />,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 102 102"
        id="instagram"
      >
        <defs>
          <radialGradient
            id="a"
            cx="6.601"
            cy="99.766"
            r="129.502"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".09" stopColor="#fa8f21"></stop>
            <stop offset=".78" stopColor="#d82d7e"></stop>
          </radialGradient>
          <radialGradient
            id="b"
            cx="70.652"
            cy="96.49"
            r="113.963"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset=".64" stopColor="#8c3aaa" stopOpacity="0"></stop>
            <stop offset="1" stopColor="#8c3aaa"></stop>
          </radialGradient>
        </defs>
        <path
          fill="url(#a)"
          d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361"
        ></path>
        <path
          fill="url(#b)"
          d="M25.865,101.639A34.341,34.341,0,0,1,14.312,99.5a19.329,19.329,0,0,1-7.154-4.653A19.181,19.181,0,0,1,2.5,87.694,34.341,34.341,0,0,1,.364,76.142C.061,69.584,0,67.617,0,51s.067-18.577.361-25.14A34.534,34.534,0,0,1,2.5,14.312,19.4,19.4,0,0,1,7.154,7.154,19.206,19.206,0,0,1,14.309,2.5,34.341,34.341,0,0,1,25.862.361C32.422.061,34.392,0,51,0s18.577.067,25.14.361A34.534,34.534,0,0,1,87.691,2.5a19.254,19.254,0,0,1,7.154,4.653A19.267,19.267,0,0,1,99.5,14.309a34.341,34.341,0,0,1,2.14,11.553c.3,6.563.361,8.528.361,25.14s-.061,18.577-.361,25.14A34.5,34.5,0,0,1,99.5,87.694,20.6,20.6,0,0,1,87.691,99.5a34.342,34.342,0,0,1-11.553,2.14c-6.557.3-8.528.361-25.14.361s-18.577-.058-25.134-.361"
        ></path>
        <path
          fill="#fff"
          d="M461.114,477.413a12.631,12.631,0,1,1,12.629,12.632,12.631,12.631,0,0,1-12.629-12.632m-6.829,0a19.458,19.458,0,1,0,19.458-19.458,19.457,19.457,0,0,0-19.458,19.458m35.139-20.229a4.547,4.547,0,1,0,4.549-4.545h0a4.549,4.549,0,0,0-4.547,4.545m-30.99,51.074a20.943,20.943,0,0,1-7.037-1.3,12.547,12.547,0,0,1-7.193-7.19,20.923,20.923,0,0,1-1.3-7.037c-.184-3.994-.22-5.194-.22-15.313s.04-11.316.22-15.314a21.082,21.082,0,0,1,1.3-7.037,12.54,12.54,0,0,1,7.193-7.193,20.924,20.924,0,0,1,7.037-1.3c3.994-.184,5.194-.22,15.309-.22s11.316.039,15.314.221a21.082,21.082,0,0,1,7.037,1.3,12.541,12.541,0,0,1,7.193,7.193,20.926,20.926,0,0,1,1.3,7.037c.184,4,.22,5.194.22,15.314s-.037,11.316-.22,15.314a21.023,21.023,0,0,1-1.3,7.037,12.547,12.547,0,0,1-7.193,7.19,20.925,20.925,0,0,1-7.037,1.3c-3.994.184-5.194.22-15.314.22s-11.316-.037-15.309-.22m-.314-68.509a27.786,27.786,0,0,0-9.2,1.76,19.373,19.373,0,0,0-11.083,11.083,27.794,27.794,0,0,0-1.76,9.2c-.187,4.04-.229,5.332-.229,15.623s.043,11.582.229,15.623a27.793,27.793,0,0,0,1.76,9.2,19.374,19.374,0,0,0,11.083,11.083,27.813,27.813,0,0,0,9.2,1.76c4.042.184,5.332.229,15.623.229s11.582-.043,15.623-.229a27.8,27.8,0,0,0,9.2-1.76,19.374,19.374,0,0,0,11.083-11.083,27.716,27.716,0,0,0,1.76-9.2c.184-4.043.226-5.332.226-15.623s-.043-11.582-.226-15.623a27.786,27.786,0,0,0-1.76-9.2,19.379,19.379,0,0,0-11.08-11.083,27.748,27.748,0,0,0-9.2-1.76c-4.041-.185-5.332-.229-15.621-.229s-11.583.043-15.626.229"
          transform="translate(-422.637 -426.196)"
        ></path>
        <span className="text-sm font-medium">Instagram</span>
      </svg>
    ),
    bgColor: "bg-white backdrop-blur-sm ",
    delay: "delay-500",
  },
  {
    title: "Facebook",
    url: "https://www.facebook.com/share/o9HvFxKmkYcSFozL/?mibextid=LQQJ4d",
    // icon: <Facebook className="h-6 w-6 text-blue-600" />,
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        viewBox="0 0 16 16"
        width={20}
        height={20}
        id="facebook"
      >
        <path
          fill="#1976D2"
          d="M14 0H2C.897 0 0 .897 0 2v12c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2z"
        ></path>
        <path
          fill="#FAFAFA"
          fillRule="evenodd"
          d="M13.5 8H11V6c0-.552.448-.5 1-.5h1V3h-2a3 3 0 0 0-3 3v2H6v2.5h2V16h3v-5.5h1.5l1-2.5z"
          clipRule="evenodd"
        ></path>
      </svg>
    ),
    bgColor: "bg-white backdrop-blur-sm ",
    delay: "delay-600",
  },
  {
    title: "Email",
    url: "mailto:centurygroup.global@gmail.com",
    icon: <Mail className="h-6 w-6 text-black" />,
    bgColor: "bg-white backdrop-blur-sm ",
    delay: "delay-100",
  },
];

// Video Carousel Component
const VideoCarousel = () => {
  const [selectedVideo, setSelectedVideo] = useState<string | null>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const dialogRef = useRef<HTMLDialogElement>(null);
  const titleRef = useRef<HTMLHeadingElement>(null);
  const sliderRef = useRef<HTMLDivElement>(null);

  // Items array with YouTube video URLs
  const items = [
    {
      img: "/assets/imgs/Testimonials/1.webp",
      videoUrl: "https://www.youtube.com/embed/KRtzLXqpm6U",
    },
    {
      img: "/assets/imgs/Testimonials/2.webp",
      videoUrl: "https://www.youtube.com/embed/oBnOW1s2R1Q",
    },
    {
      img: "/assets/imgs/Testimonials/3.webp",
      videoUrl: "https://www.youtube.com/embed/Cr5vAnVTQXU",
    },
    {
      img: "/assets/imgs/Testimonials/4.webp",
      videoUrl: "https://www.youtube.com/embed/bgHzzVU7IUM",
    },
    {
      img: "/assets/imgs/Testimonials/5.webp",
      videoUrl: "https://www.youtube.com/embed/gu4QH-laUoU",
    },
    {
      img: "/assets/imgs/Testimonials/6.webp",
      videoUrl: "https://www.youtube.com/embed/mi7gezKpHLk",
    },
    {
      img: "/assets/imgs/Testimonials/7.webp",
      videoUrl: "https://www.youtube.com/embed/Cx039VURwac",
    },
    {
      img: "/assets/imgs/Testimonials/8.webp",
      videoUrl: "https://www.youtube.com/embed/_rDNGd7Y-_Q",
    },
  ];

  // Auto-slide functionality
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % items.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [items.length]);

  // Disable background scrolling when modal is open
  useEffect(() => {
    if (selectedVideo) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [selectedVideo]);

  // Handle thumbnail click
  const handleThumbnailClick = (videoUrl: string) => {
    setSelectedVideo(videoUrl);
    dialogRef.current?.showModal();
  };

  // Close modal
  const closeModal = () => {
    setSelectedVideo(null);
    dialogRef.current?.close();
  };

  // Handle outside click (backdrop click)
  const handleDialogClick = (event: React.MouseEvent<HTMLDialogElement>) => {
    if (event.target === dialogRef.current) {
      closeModal();
    }
  };

  // Navigate slides
  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % items.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + items.length) % items.length);
  };

  return (
    <>
      <div className="mb-8 w-full">
        <div className="mb-6 flex items-center justify-center">
          <h2
            ref={titleRef}
            className="text-center text-xl font-bold drop-shadow-lg sm:text-2xl"
          >
            Testimonials
          </h2>
        </div>

        {/* Custom Carousel */}
        <div ref={sliderRef} className="relative">
          <div className="overflow-hidden rounded-lg">
            <div
              className="flex transition-transform duration-500 ease-in-out"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {items.map((item, index) => (
                <div key={index} className="w-full flex-shrink-0">
                  <img
                    src={item.img}
                    alt={`Testimonial ${index + 1}`}
                    className="h-48 w-full cursor-pointer rounded-lg object-cover transition-transform duration-200 hover:scale-105 sm:h-56 md:h-64 lg:h-72"
                    onClick={() => handleThumbnailClick(item.videoUrl)}
                    onError={(e) => {
                      const target = e.target as HTMLImageElement;
                      target.src = `https://via.placeholder.com/400x300/4F46E5/FFFFFF?text=Video+${index + 1}`;
                    }}
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Arrows */}
          <button
            onClick={prevSlide}
            className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white transition-all hover:bg-black/70 focus:outline-none"
            aria-label="Previous slide"
          >
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>

          <button
            onClick={nextSlide}
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 p-2 text-white transition-all hover:bg-black/70 focus:outline-none"
            aria-label="Next slide"
          >
            <svg
              className="h-4 w-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </button>

          {/* Dots Navigation */}
          <div className="mt-4 flex justify-center space-x-2">
            {items.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`h-2 w-2 rounded-full transition-all focus:outline-none ${
                  index === currentSlide ? "bg-blue-600" : "bg-gray-300"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      {/* Dialog for video playback */}
      <dialog
        ref={dialogRef}
        onClick={handleDialogClick}
        className="w-[95%] max-w-[90vw] rounded-lg bg-transparent p-0 backdrop:bg-black backdrop:bg-opacity-50 sm:w-[90%] sm:max-w-[800px]"
      >
        <div className="relative">
          {/* Close button */}
          <button
            onClick={closeModal}
            className="absolute -top-8 right-0 text-2xl text-white transition-transform hover:scale-110 focus:outline-none sm:-top-10 sm:text-3xl"
            aria-label="Close video modal"
          >
            ×
          </button>
          {/* YouTube iframe */}
          {selectedVideo && (
            <iframe
              width="100%"
              height="250"
              src={`${selectedVideo}?autoplay=1&rel=0&showinfo=0`}
              title="Testimonial Video"
              className="rounded-lg sm:h-[300px] md:h-[400px] lg:h-[450px]"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          )}
        </div>
      </dialog>
    </>
  );
};

const LinksPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const handleLinkClick = (title: string, url: string) => {
    trackLinkClick(title, url);
  };

  return (
    <div
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-[#ebeef1] px-4 py-8 sm:px-6 lg:px-8"
      style={{ fontFamily: "GT-Ultra" }}
    >
      <div className="relative z-10 mx-auto w-full max-w-md sm:max-w-lg">
        {/* Header */}
        <div
          className={`mb-6 transform text-center transition-all duration-1000 sm:mb-8 ${
            isLoaded ? "translate-y-0 opacity-100" : "-translate-y-10 opacity-0"
          }`}
        >
          {/* Logo */}
          <div className="my-12 lg:mb-14 lg:mt-8">
            <div className="mx-auto flex h-16 items-center justify-center rounded-2xl">
              <img src="/assets/imgs/CenturyLogo.png" alt="" />
            </div>
          </div>

          {/* Company Info */}
          {/* <h1 className="mb-2 text-3xl font-bold drop-shadow-lg">
            Century Group
          </h1> */}
          <p className="text-lg leading-relaxed">
            Century Group | Real Estate | Education | Consultancy
          </p>
        </div>

        {/* Links */}
        <div className="mb-6 space-y-3 sm:space-y-4">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => handleLinkClick(link.title, link.url)}
              className={`block w-full transform rounded-lg p-3 text-center font-semibold transition-all duration-300 hover:scale-[0.98] hover:shadow-2xl focus:border-none focus:outline-none active:scale-95 sm:p-4 ${link.bgColor} ${link.delay} ${
                isLoaded
                  ? "translate-y-0 opacity-100"
                  : "translate-y-10 opacity-0"
              } shadow-lg hover:shadow-white/10`}
            >
              <div className="flex items-center justify-center space-x-2 sm:space-x-3">
                <div className="flex-shrink-0">
                  <div className="h-5 w-5 sm:h-6 sm:w-6">{link.icon}</div>
                </div>
                <span className="text-base sm:text-lg">{link.title}</span>
              </div>
            </a>
          ))}
        </div>

        {/* Video Carousel */}
        <VideoCarousel />
      </div>
    </div>
  );
};

export default LinksPage;
